// extracted by mini-css-extract-plugin
export var colorSquare = "_t7-0";
export var danger = "_t7-5";
export var lightPink = "_t7-8";
export var neutralBlue = "_t7-7";
export var neutralYellow = "_t7-6";
export var normal = "_t7-1";
export var primary = "_t7-2";
export var primaryLight = "_t7-3";
export var solidBlack = "_t7-g";
export var solidGreen = "_t7-b";
export var solidLightBlue = "_t7-d";
export var solidNavy = "_t7-c";
export var solidOrange = "_t7-f";
export var solidPink = "_t7-e";
export var solidRed = "_t7-9";
export var solidYellow = "_t7-a";
export var success = "_t7-4";